module.exports = __webpack_public_path__ + "static/media/menu-background.fcdbf4fa.png";